import React from 'react';
import { TMessage } from '../../store/sockets/types';
import { checkUserType } from '../../utils/checkUserType';
import { Message } from '../Chat/components/Message';
import { WrapperMessage } from './styles';

interface MessageUnderVideoProps {
  isFullScreen: boolean;
  message: TMessage;
  likeMessage: (messageId: number) => void;
}

export const MessageUnderVideo: React.FC<MessageUnderVideoProps> = React.memo(({ isFullScreen, message, likeMessage }) => {
  return (
    <WrapperMessage isFullScreen={isFullScreen}>
      <Message type={checkUserType(message)} message={message} likeMessage={() => likeMessage(message.absnum)} />
    </WrapperMessage>
  );
});
